<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>配置管理</el-breadcrumb-item>
      <el-breadcrumb-item>流程负责人</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="row">
      <div class="col-sm-12">
        <div class="panel">
          <!-- <div class="panel-heading">
            <h3 class="panel-title pl-0">流程步骤</h3>
          </div> -->
          <div class="">
            <el-tabs v-model="activeName">
              <el-tab-pane
                v-for="item in tabs"
                :label="item.name"
                :name="item.id"
                :key="item.id"
              >
                <div class="type-container">
                  <div
                    class="type-list"
                    v-for="(k, dv) in DrillTypeMap"
                    :key="dv"
                  >
                    <div class="block-list">{{ k }}</div>
                    <div v-for="(k, bv) in BlockTypeMap" :key="bv">
                      <div class="mt-10">{{ k }}</div>
                      <UserSelect
                        class="long"
                        :code="item.auth_code"
                        :value="getUserIds(item.id, dv, bv)"
                        @input="updateUserIds($event, item.id, dv, bv)"
                      ></UserSelect>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderFlowSetList, orderFlowSetUpdate } from '@/service/getData'
import { DrillTypeMap, BlockTypeMap } from '../../../config/global'
import UserSelect from './select.vue'

const params = [
  {
    id: '1',
    name: '负责人审核',
    auth_code: '32109',
  },
  {
    id: '4',
    name: '模型发送确认',
    auth_code: '32107',
  },
]

export default {
  components: {
    UserSelect,
  },
  data() {
    return {
      DrillTypeMap,
      BlockTypeMap,
      tabs: params,
      activeName: params[0].id,
      sets: [],
      user_ids: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      let res = await orderFlowSetList()
      if (res.status != 0) return false
      this.sets = res.data.list
      this.loading = false
    },
    getUserIds(step, dt, bt) {
      let sets = this.sets.filter(
        (item) =>
          item.step == step && item.drill_type == dt && item.block_type == bt
      )
      return sets.length > 0 ? sets[0].user_ids : []
    },
    async updateUserIds(e, step, dt, bt) {
      let res = await orderFlowSetUpdate({
        step: parseInt(step),
        drill_type: parseInt(dt),
        block_type: parseInt(bt),
        user_ids: e,
      })
      if (res.code == 0) {
        this.$message.success('保存成功')
      }
    },
  },
}
</script>

<style scoped>
.type-container {
  display: flex;
  justify-content: space-between;
}
.type-list {
  width: 32%;
  border: 1px solid #ecf0f5;
  border-radius: 4px;
  padding: 10px;
}

.block-list {
  margin-bottom: 10px;
  font-weight: bold;
}
</style>